// In-memory, server-confirmed binding. Never trust a cached domain->tenant value.
let tenant = null;
export function getHostTenant() { return tenant; }
export function tenantLoginPath(slug) {
  return tenant ? '/login' : (slug ? `/${encodeURIComponent(slug)}/login` : '/');
}
export async function initializeTenantHost() {
  const response = await fetch('/api/tenants/resolve-host', { cache: 'no-store', credentials: 'same-origin' });
  const data = await response.json();
  if (!response.ok) throw new Error(data.message || 'Não foi possível identificar a empresa.');
  if (data.host && data.host !== window.location.hostname.toLowerCase().replace(/\.$/, '')) {
    throw new Error('O proxy não preservou o domínio de acesso. Contate o administrador.');
  }
  if (!['shared', 'dedicated'].includes(data.mode)
    || (data.mode === 'dedicated' && !/^[a-z0-9_-]+$/.test(data.tenant?.slug || ''))) {
    throw new Error('Resposta inválida ao identificar a empresa.');
  }
  tenant = data.mode === 'dedicated' ? data.tenant : null;
  return tenant;
}
